import getConfig from "src/config/appConfig";
import agendaApiConfig from "./agendaApiConfig";

const SpecialityService = {
  async getBySueCorrel(modalidad, sueCorrel = null, staCorrel = 1) {
    const { SUCURSAL } = getConfig();
    let sucursales = sueCorrel ?? SUCURSAL;
    if (!SUCURSAL && !sueCorrel) {
      sucursales = sessionStorage.getItem("SUCURSAL");
    }
    return await agendaApiConfig.get("/v2/especialidad", {
      params: {
        suecorrel: sucursales,
        stacorrel: staCorrel,
      },
      headers: {
        "X-Origin": process.env.REACT_APP_HEADER,
      },
    });
  },
  async getAll(modalidad) {
    const { SERVICIO } = getConfig();
    let query = {};
    if (SERVICIO == "") {
      query = null;
    } else {
      query = { ser_codigo: SERVICIO, tipo: modalidad };
    }
    return await agendaApiConfig.get("/especialidad", {
      params: {
        ...query,
      },
    });
  },
  async getByService(codeService, modalidad) {
    let query = {};
    query = { SER_CODIGO: codeService, tipo: modalidad };
    return await agendaApiConfig.get("/especialidad", {
      params: {
        ...query,
      },
    });
  },
  async getProfessionals(codeSpeciality = 0, modalidad) {
    //return await agendaApiConfig.get(`/especialidad/${codeSpeciality}/profesionales`);
    const { SERVICIO } = getConfig();
    let query = {};
    if (SERVICIO == "") {
      query = null;
    } else {
      query = { SER_CODIGO: SERVICIO, tipo: modalidad };
    }
    return await agendaApiConfig.get(
      `/especialidad/${codeSpeciality}/profesionales`,
      {
        params: {
          ...query,
        },
      },
    );
  },
  async getProfessionalsByService(codeSpeciality = 0, codeService, modalidad) {
    //return await agendaApiConfig.get(`/especialidad/${codeSpeciality}/profesionales`);
    const { SERVICIO } = getConfig();
    let query = {};
    if (codeService == null) {
      query = { SER_CODIGO: SERVICIO, tipo: modalidad };
    } else {
      //query = null;
      query = { SER_CODIGO: codeService, tipo: modalidad };
    }
    //query =  {SER_CODIGO : codeService };
    return await agendaApiConfig.get(
      `/especialidad/${codeSpeciality}/profesionales`,
      {
        params: {
          ...query,
        },
      },
    );
  },
};

export default SpecialityService;
